import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ScanLine, Trash2, Plus, CheckCircle2, AlertTriangle } from 'lucide-react';

/** Step 2 del carico multiplo (modalità codici): tabella unità scansionate. */
export const BulkStepUnits = ({ units, validCount, scanTarget, setScanTarget, updateRow, removeRow, addEmptyRow }) => (
  <div className="space-y-3 py-2">
    {/* Info scanner */}
    <div className="rounded-md bg-cyan-50 dark:bg-cyan-950/20 border border-cyan-200 dark:border-cyan-900 p-3 text-sm flex items-start gap-2">
      <ScanLine className="h-5 w-5 text-cyan-600 shrink-0 mt-0.5" />
      <div className="flex-1">
        <div className="font-semibold text-cyan-800 dark:text-cyan-300">Scanner USB attivo</div>
        <div className="text-xs text-cyan-700 dark:text-cyan-400">
          Scansiona ora ogni cassa. Ogni scan aggiunge una riga sotto.
        </div>
      </div>
      <div>
        <Select value={scanTarget} onValueChange={setScanTarget}>
          <SelectTrigger className="w-40 h-8 text-xs" data-testid="bulk-scan-target">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="auto">Auto (EAN → Matr.)</SelectItem>
            <SelectItem value="barcode">Solo Codice EAN</SelectItem>
            <SelectItem value="matricola">Solo Matricola</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>

    {/* Tabella righe */}
    <div className="border rounded-none">
      <div className="grid grid-cols-12 gap-2 px-3 py-2 bg-muted text-[10px] font-mono uppercase text-muted-foreground">
        <div className="col-span-1">#</div>
        <div className="col-span-5">Codice EAN / Barcode</div>
        <div className="col-span-5">Matricola</div>
        <div className="col-span-1"></div>
      </div>
      <div className="divide-y max-h-[40vh] overflow-y-auto">
        {units.map((u, idx) => (
          <div key={u._uid || `unit-${idx}`} className="grid grid-cols-12 gap-2 px-3 py-2 items-center" data-testid={`bulk-row-${idx}`}>
            <div className="col-span-1 text-xs text-muted-foreground font-mono">{idx + 1}</div>
            <Input
              value={u.codice_barre}
              onChange={(e) => updateRow(idx, 'codice_barre', e.target.value)}
              placeholder="8001234567890"
              className="col-span-5 rounded-none font-mono text-xs h-8"
              data-testid={`bulk-row-${idx}-barcode`}
            />
            <Input
              value={u.matricola}
              onChange={(e) => updateRow(idx, 'matricola', e.target.value)}
              placeholder="EP2026001"
              className="col-span-5 rounded-none font-mono text-xs h-8"
              data-testid={`bulk-row-${idx}-matricola`}
            />
            <button
              onClick={() => removeRow(idx)}
              className="col-span-1 text-rose-500 hover:text-rose-700"
              title="Rimuovi riga"
              data-testid={`bulk-row-${idx}-remove`}
            >
              <Trash2 className="h-4 w-4 mx-auto" />
            </button>
          </div>
        ))}
      </div>
      <div className="border-t p-2">
        <Button
          type="button"
          variant="ghost"
          size="sm"
          onClick={addEmptyRow}
          className="w-full"
          data-testid="bulk-add-row"
        >
          <Plus className="h-3 w-3 mr-1" />
          Aggiungi riga manuale
        </Button>
      </div>
    </div>

    {/* Riepilogo */}
    <div className="flex items-center gap-2 text-sm">
      <CheckCircle2 className="h-4 w-4 text-emerald-500" />
      <span className="font-semibold">{validCount}</span>
      <span className="text-muted-foreground">unità pronte da salvare</span>
      {units.length - validCount > 0 && (
        <>
          <AlertTriangle className="h-4 w-4 text-amber-500 ml-2" />
          <span className="text-xs text-amber-700 dark:text-amber-400">
            {units.length - validCount} righe vuote saranno ignorate
          </span>
        </>
      )}
    </div>
  </div>
);
